import { render, staticRenderFns } from "./GenderFilter.vue?vue&type=template&id=04ac34c0&"
import script from "./GenderFilter.vue?vue&type=script&lang=js&"
export * from "./GenderFilter.vue?vue&type=script&lang=js&"
import style0 from "./GenderFilter.vue?vue&type=style&index=0&id=04ac34c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports